// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";

function GiftCardPinInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userGiftCardPin);
  var setGiftCardPin = match$1[1];
  var giftCardPin = match$1[0];
  var giftCardPinRef = React.useRef(null);
  var updateGiftCardPin = function (val) {
    setGiftCardPin(function (param) {
          return {
                  value: val,
                  isValid: val !== "",
                  errorString: val !== "" ? "" : localeString.giftCardPinEmptyText
                };
        });
  };
  var changeGiftCardPin = function (ev) {
    var val = ev.target.value;
    updateGiftCardPin(val);
  };
  var onBlurGiftCardPin = function (ev) {
    var val = ev.target.value;
    updateGiftCardPin(val);
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && giftCardPin.value === "") {
            return setGiftCardPin(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = localeString.giftCardPinEmptyText;
                        return newrecord;
                      });
          }
          
        }), [giftCardPin.value]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(PaymentField$OrcaPaymentPage.make, {
              setValue: setGiftCardPin,
              value: giftCardPin,
              onChange: changeGiftCardPin,
              onBlur: onBlurGiftCardPin,
              fieldName: localeString.giftCardPinLabel,
              name: "giftCardPin",
              type_: "text",
              paymentType: "Payment",
              maxLength: 12,
              placeholder: localeString.giftCardPinPlaceholder,
              inputRef: giftCardPinRef
            });
}

var make = GiftCardPinInput;

export {
  make ,
}
/* react Not a pure module */
